import { format } from 'date-fns';
import { FORMAT } from '@app/constants/formats';
import { EmailRecentProblemOutDto } from '@app/swagger-types';

import { EmailCard } from '../../shared/EmailCard';

// admin-emailbeheer blok B (opdracht §7: "Lijst met recente harde bounces en klachten, met de
// reason en de bounce_classification van SendGrid erbij"). Already excludes soft bounces on the
// backend - every row here is worth a look.
export const EmailRecentProblemsTable: React.FC<{ rows: EmailRecentProblemOutDto[] }> = ({ rows }) => {
  return (
    <EmailCard title="Recent hard bounces & complaints">
      <div className="overflow-x-auto">
        <table className="w-full text-left text-xs">
          <thead>
            <tr className="border-b border-gray-200 text-gray-400">
              <th className="py-2 pr-3">Timestamp</th>
              <th className="py-2 pr-3">Recipient</th>
              <th className="py-2 pr-3">Type</th>
              <th className="py-2 pr-3">Reason</th>
              <th className="py-2">Classification</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={i} className={i % 2 === 1 ? 'bg-gray-50' : undefined}>
                <td className="py-1.5 pr-3 text-gray-400">
                  {row.occurredAt ? format(new Date(row.occurredAt), FORMAT.FULL_TIME) : '-'}
                </td>
                <td className="py-1.5 pr-3">{row.recipientEmail || '-'}</td>
                <td className="py-1.5 pr-3 font-bold text-[#c23c3c]">{row.eventType}</td>
                <td className="py-1.5 pr-3 text-gray-700">{row.reason || '-'}</td>
                <td className="py-1.5 text-gray-500">{row.bounceClassification || '-'}</td>
              </tr>
            ))}
            {!rows.length && (
              <tr>
                <td colSpan={5} className="py-4 text-center text-gray-400">
                  No hard bounces or complaints in this period.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </EmailCard>
  );
};
